import * as palette from "../../../../palette";

export const pipThemeColor = palette.grape[500];

export function setThemeColor(color: string) {
  const themeMetaEl = document.getElementById("meta-theme-color");

  if (themeMetaEl) themeMetaEl.setAttribute("content", color);
}
